import { useMemo } from "react";
import { useAssetEntries } from "../../../stores/assetStore";
import { useTextures } from "../../../stores/sceneStore";
import { useTexturePreviewUrlByKey } from "./useTexturePreviewUrlByKey";

export const useMaterialTextureOptions = () => {
  const assetEntries = useAssetEntries();
  const textures = useTextures();

  const textureOptions = useMemo(() => {
    const opts = [];
    Object.entries(textures).forEach(([name, texture]) => {
      const fingerprint = texture?.fingerprint;
      const assetEntry = fingerprint ? assetEntries?.[fingerprint] : undefined;
      const label = texture?.name || assetEntry?.name || name;
      opts.push({ name, label });
    });
    return opts.sort((a, b) => (a.label > b.label ? 1 : -1));
  }, [textures, assetEntries]);

  const texturePreviewUrlByKey = useTexturePreviewUrlByKey({ textures, assetEntries });

  return {
    assetEntries,
    textures,
    textureOptions,
    texturePreviewUrlByKey,
  };
};
